export enum TemplatePlaceholderPlacements {
	PRIMARY = 'PRIMARY',
	GROUPING_SORT_METRIC = 'GROUPING_SORT_METRIC',
	SELECTION = 'SELECTION',
	SERIES = 'SERIES'
}